/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import bus from '../bus';
import Swal from 'sweetalert2';
const __vue_script__ = {
	props: {
		songtitle: String,
	},
	data() {
		return {
		   isOpen: false,
		   track: {},
		   nonce: ui_data.nonce
		}
	},
	methods: {
		closeDialog(event) {
			if ( event.target === this.$el ) {
				this.isOpen = false;
				this.$refs.freeDownloadModal.close();
				document.body.classList.remove('modal-is-open');
			}
		},
		async handleSubmit(e) {
			e.preventDefault();

			let res = await fetch('/wp-json/beatstore/v1/subscribe', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-WP-Nonce': this.nonce,
				},
				body: JSON.stringify({
					email: this.$refs.email.value,
					name: this.$refs.name.value,
					id: this.track.id,
					nonce: this.nonce,
				}),
			})
		
			if ( res.status === 200 ) {
				//clear form
				this.$refs.email.value = '';
				this.$refs.name.value = '';
				
				Swal.fire({
					position: 'center',
					title: "Success! Your download link will be sent to your email.",
					icon: 'success',
					showConfirmButton: false,
					toast: true,
					timer: 3500
				})
			} else {
				Swal.fire({
					position: 'center',
					title: "Something went wrong. Please try again.",
					icon: 'error',
					showConfirmButton: false,
					toast: true,
					timer: 3500
				})
			}

			this.$refs.freeDownloadModal.close();
			this.isOpen = false;
			document.body.classList.remove('modal-is-open');
		},
	},
	mounted() {
		bus.$on('openDownloadModal', (track) => {
			this.$refs.freeDownloadModal.showModal();
			this.isOpen = true;
			this.track = track;
			document.body.classList.add('modal-is-open');
		});

		bus.$on('closeDownloadModal', () => {
			this.isOpen = false;
			this.$refs.freeDownloadModal.close();
			document.body.classList.remove('modal-is-open');
		});
	},
}

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],ref:"freeDownloadModal",staticClass:"free-download-modal",on:{"click":_vm.closeDialog}},[_c('div',{staticClass:"free-download-modal-details"},[_c('header',[_c('div',[_c('p',{staticClass:"free-download-headline"},[_vm._v("Free Download")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.track.title))])]),_vm._v(" "),_c('form',{staticClass:"close-form",attrs:{"method":"dialog"}},[_c('button',{attrs:{"aria-label":"Close dialog"},on:{"click":function($event){_vm.isOpen = false}}},[_c('svg',{staticClass:"text-black",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 357 357","width":"16","height":"16"}},[_c('path',{attrs:{"fill":"#eee","d":"M357 35.7L321.3 0 178.5 142.8 35.7 0 0 35.7l142.8 142.8L0 321.3 35.7 357l142.8-142.8L321.3 357l35.7-35.7-142.8-142.8z"}})])])])]),_vm._v(" "),_c('main',[_c('p',{staticClass:"free-download-instructions"},[_vm._v("\n\t\t\t\tPlease enter your name and email address and the download link will be emailed to you.\n\t\t\t")]),_vm._v(" "),_c('form',{staticClass:"free-download-form",on:{"submit":_vm.handleSubmit}},[_c('label',[_vm._v("\n\t\t\t\t\tEmail Address\n\t\t\t\t\t"),_c('input',{ref:"email",attrs:{"required":"","name":"email","type":"email","placeholder":"Email"}})]),_vm._v(" "),_c('label',[_vm._v("\n\t\t\t\t\tName\n\t\t\t\t\t"),_c('input',{ref:"name",attrs:{"required":"","name":"name","type":"text","placeholder":"Your Name"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"nonce"},domProps:{"value":_vm.nonce}})])])])])}
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-send-email",attrs:{"type":"submit"}},[_c('span',{staticClass:"text-xs font-bold"},[_vm._v("Send")])])}]

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "FreeDownloadModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__